<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <input
            :dir="dir"
            :id="id"
            :placeholder="placeHolder"
            :class="{ error: error }"
            :type="type"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <div v-if="error" class="form-error">
            <p class="m-0 text-sm text-error mb-3">{{ error }}</p>
        </div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
    inheritAttrs: false,
    props: {
        ref: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`;
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        placeHolder: {
            type: String,
            default: '',
        },
        dir: {
            type: String,
            default: 'rtl',
        },
        error: String,
        label: String,
        modelValue: String,
    },
    emits: ['update:modelValue'],
}
</script>
